import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CategoryCard from '../components/CategoryCard';
import { CategoryGridSkeleton } from '../components/Skeleton';
import ErrorState from '../components/ErrorState';
import usePageMetadata from '../hooks/usePageMetadata';
import * as catalogApi from '../api/endpoints/catalog';
import { containerWide, pageHeading, pageSection } from '../styles/ui';

const CategoryListingPage = () => {
  const [state, setState] = useState({ status: 'loading', data: null, error: null });

  usePageMetadata({
    title: 'Shop by Category | Fresh & Homely',
    description: 'Browse fresh meat, seafood, dairy and grocery categories at Fresh & Homely.',
    canonicalPath: '/categories',
  });

  const load = () => {
    setState({ status: 'loading', data: null, error: null });
    catalogApi
      .listCategories()
      .then((response) => setState({ status: 'success', data: response.data, error: null }))
      .catch((err) => setState({ status: 'error', data: null, error: err.message }));
  };

  useEffect(load, []);

  return (
    <>
      <Navbar />
      <section className={pageSection}>
        <div className={containerWide}>
          <div className="text-center mb-16">
            <h1 className={`${pageHeading} mb-4`}>Shop by Category</h1>
            <p className="text-ink-secondary max-w-2xl mx-auto">
              Explore our full range of handpicked fresh products.
            </p>
          </div>

          {state.status === 'loading' && <CategoryGridSkeleton count={8} />}
          {state.status === 'error' && <ErrorState message={state.error} onRetry={load} />}
          {state.status === 'success' && (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
              {state.data.map((category) => (
                <CategoryCard
                  key={category.key}
                  categoryKey={category.key}
                  label={category.label}
                  count={category.count}
                  isEmpty={category.isEmpty}
                  iconHint={category.iconHint}
                />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CategoryListingPage;
